/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

export interface GetAuditConfigRequest {
    sessionId?: string;
}

export interface GetEffectivePolicyRequest {
    sessionId?: string;
}

export interface GetTenantPolicyRequest {
    tenantId: string;
    sessionId?: string;
}

export interface ResetTenantPolicyRequest {
    tenantId: string;
    sessionId?: string;
}

export interface SetTenantPolicyRequest {
    tenantId: string;
    requestBody: { [key: string]: string; };
    sessionId?: string;
}

/**
 * AuditPolicyManagementApi - interface
 * 
 * @export
 * @interface AuditPolicyManagementApiInterface
 */
export interface AuditPolicyManagementApiInterface {
    /**
     * Get the current audit logging configuration
     * @summary Get audit logging configuration
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditPolicyManagementApiInterface
     */
    getAuditConfigRaw(requestParameters: GetAuditConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get the current audit logging configuration
     * Get audit logging configuration
     */
    getAuditConfig(requestParameters: GetAuditConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Get the effective audit policy for the current session
     * @summary Get effective audit policy
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditPolicyManagementApiInterface
     */
    getEffectivePolicyRaw(requestParameters: GetEffectivePolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get the effective audit policy for the current session
     * Get effective audit policy
     */
    getEffectivePolicy(requestParameters: GetEffectivePolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Get the audit policy for a specific tenant
     * @summary Get tenant audit policy
     * @param {string} tenantId Tenant ID
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditPolicyManagementApiInterface
     */
    getTenantPolicyRaw(requestParameters: GetTenantPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get the audit policy for a specific tenant
     * Get tenant audit policy
     */
    getTenantPolicy(requestParameters: GetTenantPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Reset the audit policy for a specific tenant to default
     * @summary Reset tenant audit policy
     * @param {string} tenantId Tenant ID
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditPolicyManagementApiInterface
     */
    resetTenantPolicyRaw(requestParameters: ResetTenantPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Reset the audit policy for a specific tenant to default
     * Reset tenant audit policy
     */
    resetTenantPolicy(requestParameters: ResetTenantPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Set the audit policy for a specific tenant
     * @summary Set tenant audit policy
     * @param {string} tenantId Tenant ID
     * @param {{ [key: string]: string; }} requestBody 
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditPolicyManagementApiInterface
     */
    setTenantPolicyRaw(requestParameters: SetTenantPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Set the audit policy for a specific tenant
     * Set tenant audit policy
     */
    setTenantPolicy(requestParameters: SetTenantPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

}

/**
 * 
 */
export class AuditPolicyManagementApi extends runtime.BaseAPI implements AuditPolicyManagementApiInterface {

    /**
     * Get the current audit logging configuration
     * Get audit logging configuration
     */
    async getAuditConfigRaw(requestParameters: GetAuditConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/audit-policy/config`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get the current audit logging configuration
     * Get audit logging configuration
     */
    async getAuditConfig(requestParameters: GetAuditConfigRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getAuditConfigRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the effective audit policy for the current session
     * Get effective audit policy
     */
    async getEffectivePolicyRaw(requestParameters: GetEffectivePolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/audit-policy/effective`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get the effective audit policy for the current session
     * Get effective audit policy
     */
    async getEffectivePolicy(requestParameters: GetEffectivePolicyRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getEffectivePolicyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the audit policy for a specific tenant
     * Get tenant audit policy
     */
    async getTenantPolicyRaw(requestParameters: GetTenantPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getTenantPolicy().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/audit-policy/tenant/{tenantId}`;
        urlPath = urlPath.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get the audit policy for a specific tenant
     * Get tenant audit policy
     */
    async getTenantPolicy(requestParameters: GetTenantPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getTenantPolicyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Reset the audit policy for a specific tenant to default
     * Reset tenant audit policy
     */
    async resetTenantPolicyRaw(requestParameters: ResetTenantPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling resetTenantPolicy().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/audit-policy/tenant/{tenantId}`;
        urlPath = urlPath.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Reset the audit policy for a specific tenant to default
     * Reset tenant audit policy
     */
    async resetTenantPolicy(requestParameters: ResetTenantPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.resetTenantPolicyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Set the audit policy for a specific tenant
     * Set tenant audit policy
     */
    async setTenantPolicyRaw(requestParameters: SetTenantPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling setTenantPolicy().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling setTenantPolicy().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/audit-policy/tenant/{tenantId}`;
        urlPath = urlPath.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Set the audit policy for a specific tenant
     * Set tenant audit policy
     */
    async setTenantPolicy(requestParameters: SetTenantPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.setTenantPolicyRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
